import React from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import { ProgressBar } from '@intelie/ui'
import utils from 'live/lib/utils'

type Props = {
    now: number
    status: string
    duration: number
    eventCount: number
    showDetails: () => void
}
const PurgeProgressBar = ({ now, status, duration, eventCount, showDetails }: Props): JSX.Element => {
    return (
        <Container>
            <InfoContainer>
                <Status>{i18n(status.toLowerCase())}</Status>
                <Progress>{now}%</Progress>
            </InfoContainer>
            <ProgressBarContainer>
                <ProgressBar now={now} />
            </ProgressBarContainer>
            <DetailsContainer>
                <Tip>
                    <i className="fa fa-info-circle" />
                    {status === 'WAITING' || status === 'RUNNING' || status === 'CANCELING'
                        ? i18n('Purge will still run in the background if you exit this page')
                        : i18n('Executed in') +
                          ' ' +
                          utils.millisecondsToTime(duration, 0) +
                          ' ' +
                          i18n('and listed') +
                          ' ' +
                          utils.formatNumber(eventCount) +
                          ' ' +
                          i18n(eventCount === 1 ? 'event' : 'events')}
                    .
                </Tip>
                <a onClick={showDetails}>{i18n('show more')}</a>
            </DetailsContainer>
        </Container>
    )
}

const Container = styled.div`
    border-bottom: 1px solid var(--gray-400);
    padding-bottom: 12px;
`

const InfoContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
`

const Status = styled.span`
    font-size: 20px;
    font-weight: 600;
    color: var(--gray-900);
    text-transform: capitalize;
`

const Progress = styled.span`
    font-size: 16px;
    font-weight: 600;
    color: var(--gray-900);
`

const ProgressBarContainer = styled.div`
    margin-bottom: 12px;
    div {
        background: var(--gray-300);
        border-radius: 4px;
    }
    span {
        background: var(--red-700);
    }
`

const DetailsContainer = styled.div`
    display: flex;
    justify-content: space-between;
`

const Tip = styled.span`
    color: var(--gray-600);
    margin: 0px;
    i {
        margin-right: 8px;
    }
`

export default PurgeProgressBar
